import { useTheme } from '@emotion/react';

export function useGlimmerTheme() {
  return useTheme();
}
